const ITEM_LIST_LENGTH_SHORT = 16;
const ITEM_LIST_MAX_SYMBOL = 12;

const getEstheticianId = uniqueName => {
  let id = '';
  if (uniqueName) {
    try {
      const conversationPart = uniqueName.split(':')[1];
      id = conversationPart.slice(conversationPart.lastIndexOf('-') + 1);
      return id;
    } catch (err) {
      return '';
    }
  }
  return id;
};

const getClientId = uniqueName => {
  let id = '';
  if (uniqueName) {
    try {
      const conversationPart = uniqueName.split(':')[1];
      id = conversationPart.slice(0, conversationPart.lastIndexOf('-'));
      return id;
    } catch (err) {
      return '';
    }
  }
  return id;
};

const getFullName = (friendlyName, role) => {
  let firstName,
    lastName,
    fullName = '';
  try {
    fullName = friendlyName.split(' with ')[1].split(' and ')[role].trim();
    firstName = fullName.split(/\s+/)[0];
    lastName = fullName.split(/\s+/)[1];
    return `${firstName} ${lastName}`;
  } catch (err) {
    return '';
  }
};

const getClientFullName = friendlyName => {
  return getFullName(friendlyName, 0);
};

const getEstheticianFullName = friendlyName => {
  return getFullName(friendlyName, 1);
};

const getAvatarInitials = fullName => {
  if (fullName) {
    try {
      const name = fullName.split(' ');
      return name[0].charAt(0) + name[1].charAt(0);
    } catch (err) {
      return '';
    }
  } else return '';
};

/**
 * @param {string} fullName
 * @returns {string} The first name
 *
 * Limitations: assumes first name is one word.
 */
const getFirstName = fullName => {
  if (!fullName) return '';
  try {
    return fullName.split(' ')[0];
  } catch (err) {
    return '';
  }
};

/**  Function forms new FullName as string (16 symbols): FirstName :13 symbols, ' ' :1 symbol, FirstCharacter of LastName:1 symbol, '.':1 symbol
 @param {string} firstName
 @param {string} lastName
*/
const formingFullName = (firstName, lastName) => {
  let trimFirstName = firstName.substring(0, ITEM_LIST_MAX_SYMBOL);
  return `${trimFirstName} ${lastName}`;
};

/**  Function checks if FullName fits the limit. If not, then forms string to be fit.
 @param {string} fullName
*/
const checkIfFullNameFits = fullName => {
  if (fullName && fullName.length > ITEM_LIST_LENGTH_SHORT) {
    try {
      let firstName = fullName.split(/\s+/)[0];
      let lastName = fullName.split(/\s+/)[1];
      return formingFullName(firstName, getCattedString(lastName));
    } catch (err) {
      return fullName;
    }
  }
  return fullName;
};

/**  Function cuts the string to first symbol with '.'
 @param {string} name
*/
const getCattedString = name => {
  return `${name.substring(0, 1)}.`;
};

export {
  getEstheticianId,
  getClientId,
  getClientFullName,
  getEstheticianFullName,
  getAvatarInitials,
  checkIfFullNameFits,
  getFirstName,
};
